import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

type Variant = 'default' | 'success' | 'error' | 'warning' | 'info' | 'outline';

const variantClasses: Record<Variant, string> = {
  default: 'bg-primary-500/15 text-primary-300 border-primary-500/25',
  success: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/25',
  error: 'bg-red-500/15 text-red-300 border-red-500/25',
  warning: 'bg-amber-500/15 text-amber-300 border-amber-500/25',
  info: 'bg-sky-500/15 text-sky-300 border-sky-500/25',
  outline: 'border-white/15 text-zinc-300',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium',
        variantClasses[variant],
        className
      )}
      {...props}
    />
  );
}
